import axios from "axios";
import {useContext} from "react";

const LoginService = {
    async doLogin(data) {
        try {
            const response = await axios.post(
                'https://fleet.networkite.com/auth/login',
                data,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            const tokens = response.data;
            if (tokens?.token) sessionStorage.setItem('token', tokens.token);
            if (tokens?.smlToken) sessionStorage.setItem('smlToken', tokens.smlToken);
            if (tokens?.idToken) sessionStorage.setItem('idToken', tokens.idToken);
            if (tokens?.refreshToken) sessionStorage.setItem('refreshToken', tokens.refreshToken);
            return true;
        } catch (e) {
            return {
                message: e.response.data.errors
            }
        }
    }
}

export default LoginService;
